import { IRole } from 'core-components/sitebuilder/models/IRole'
import { proxyIdentity } from 'src/core/classes/helpers/UrlHelper'
import { Rest } from 'src/core/classes/http'

// TODO: REMOVE (use in LUT)
class RoleApi {
  public fetchAll = async (): Promise<IRole[]> => {
    const url = proxyIdentity(`/mbe/api/v2/app/roles`)
    const items = await this.fetchData(url, 'get')
    if (items instanceof Array && items.length) {
      return items.map((item) => this.prepareRole(item))
    }
    return []
  }

  private fetchData = async (
    url: string,
    method: 'get' | 'post' | 'put' | 'delete',
    payload?: object
  ) => {
    try {
      return await Rest[method]({ url, payload })
    } catch (err: unknown) {
      return []
    }
  }

  private prepareRole = (role: IRole) => {
    const format = Object.keys(role)
    const lowerFirstLetter = (s: string) => s.charAt(0).toLowerCase() + s.slice(1)

    const newRole = {}
    format.map((field) => {
      let value = role[field]
      if (field === 'Rules' && typeof value !== 'object') {
        value = value ? JSON.parse(value) : value
      }
      newRole[lowerFirstLetter(field)] = value
    })

    return newRole as IRole
  }
}

const roleApi = new RoleApi()
export { roleApi }
